<template>
  <dp-direct-payment-create :subNavTitle="title" :capsule="capsule" :saveMessage="saveMessage"></dp-direct-payment-create>
</template>

<script>
  import CreateTemplate from '../../requests/creationPages/DPCreateTemplate.vue'
  export default {
    name: 'Capsule-Direct-Payment-Create',
    data: () => {
      return {
        title: 'New Direct Payment',
        capsule: 'direct-payment-create',
        saveMessage: 'Draft added'
      }
    },
    components: {
      'dp-direct-payment-create': CreateTemplate
    }
  }
</script>



// WEBPACK FOOTER //
// TCreationPage.vue?29d20080